__turbopack_context__.v({
  "actionButton": "HnVz3G_actionButton",
  "actions": "HnVz3G_actions",
  "badgeWrapper": "HnVz3G_badgeWrapper",
  "buttonsWrapper": "HnVz3G_buttonsWrapper",
  "content": "HnVz3G_content",
  "image": "HnVz3G_image",
  "imageWrapper": "HnVz3G_imageWrapper",
  "img": "HnVz3G_img",
  "item": "HnVz3G_item",
  "like": "HnVz3G_like",
  "likedIcon": "HnVz3G_likedIcon",
  "playButton": "HnVz3G_playButton",
  "text": "HnVz3G_text",
  "title": "HnVz3G_title",
  "videoCta": "HnVz3G_videoCta",
  "voteCount": "HnVz3G_voteCount",
  "voteCountBadge": "HnVz3G_voteCountBadge",
  "votedLabel": "HnVz3G_votedLabel",
});
